import React from 'react';
import { ScheduleItem, ScheduleItemContract } from '@app-types';
import { UserPermissions } from '@contexts/AuthContext';
import styles from './SchedulerTableCells.module.css';

const SupplierCell: React.FC<{
  scheduleItem: ScheduleItem;
  contract: ScheduleItemContract;
  isGroupRow: boolean;
  isChildRow: boolean;
  permissions: UserPermissions;
  navigate: (path: string) => void;
}> = ({ scheduleItem, contract, isGroupRow, isChildRow, permissions, navigate }) => {
  if (isGroupRow && !isChildRow) {
    const uniqueSuppliers = new Set(scheduleItem.contracts.map((c) => c.supplier_name));
    if (uniqueSuppliers.size > 1) {
      return <span className={styles.tableText}>Multiple Suppliers</span>;
    }
  }

  if (permissions.canAccessSuppliers) {
    return (
      <button className={styles.tableLink} onClick={() => navigate(`/suppliers/${contract.supplier_id}`)}>
        {contract.supplier_name}
      </button>
    );
  }

  return <span className={styles.tableText}>{contract.supplier_name}</span>;
};

export default SupplierCell;
